// v2/utils/mapAccount.js — API cevabini v2 bilesenlerinin bekledigi sekle cevirir

// '2026-01-01' -> '01.01.2026' ; bos/gecersizse '—'
export function tarihTR(iso) {
  if (!iso) return '—';
  const p = String(iso).slice(0, 10).split('-');
  if (p.length !== 3) return '—';
  return `${p[2]}.${p[1]}.${p[0]}`;
}

// account-balance/ -> AccountCard'in bekledigi sekil
// AccountCard SADECE data.balance (sayi) ve data.lastActivity (metin) okuyor.
export function mapBalance(accountInfo) {
  const a = accountInfo || {};
  const bakiye = Number(a.balance) || 0;
  return {
    balance: Math.abs(bakiye),          // kartta mutlak deger gosteriliyor
    signedBalance: bakiye,              // isaretli hali (borclu/alacakli ayrimi)
    borclu: bakiye > 0,
    statusLabel: a.status || 'Dengede',
    totalDebt: Number(a.total_debit) || 0,
    totalCredit: Number(a.total_credit) || 0,
    lastActivity: tarihTR(a.last_transaction_date),
    lastActivityRaw: a.last_transaction_date || null,
    recentTransactions: Array.isArray(a.recent_transactions) ? a.recent_transactions : [],
  };
}

// v2/exchange-rates/ -> CurrencyCard'in bekledigi sekil
// CurrencyCard {code, label, rate, changePct} okuyor; tarih/bayatlik ek alan.
export function mapRates(rates) {
  return (Array.isArray(rates) ? rates : []).map((r) => ({
    code: r.code,
    label: r.label,
    rate: Number(r.rate) || 0,
    changePct: r.change_pct === null || r.change_pct === undefined ? null : Number(r.change_pct),
    rateDate: tarihTR(r.rate_date),
    stale: Boolean(r.stale),
    ageDays: Number(r.age_days) || 0,
  }));
}
